import BaseApi from '@/api/controller/base';

const EB_ENROLLMENT_API_URL = 'earlyBirdEnrollment/';

class EBEnrollmentApi extends BaseApi {
  constructor() {
    super(EB_ENROLLMENT_API_URL);
  }

  removeEnrollment(enrollment) {
    return this.api.post('removeEnrollment', enrollment);
  }

  getGridData(params) {
    return this.api.post('gridData', params);
  }
}

const apiInstance = new EBEnrollmentApi();
export { EBEnrollmentApi, apiInstance };
export default apiInstance;
